export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  originalPrice?: number;
  amazonRef: string;
  category: 'starter' | 'pro' | 'premium' | 'custom';
  features: string[];
  image: string;
  popular?: boolean;
  badge?: string;
  streamingBenefits: string;
}

export interface Bundle {
  id: string;
  name: string;
  description: string;
  amazonRef: string;
  products: Product[];
  category: 'starter' | 'pro' | 'premium' | 'custom';
  features: string[];
  image: string;
  popular?: boolean;
  badge?: string;
  setupIncluded: boolean;
  supportIncluded: boolean;
}

export const products: Product[] = [
  {
    id: 'stream-deck-elgato-mk2',
    name: 'Elgato Stream Deck MK.2',
    description: 'Studio-Controller mit 15 Makrotasten für OBS, Twitch, YouTube und andere Apps',
    price: 144,
    originalPrice: 169,
    amazonRef: 'https://amzn.to/42rwPfh',
    category: 'pro',
    features: [
      '15 programmierbare Makrotasten',
      'Integration mit OBS, Twitch, YouTube',
      'LCD-Tasten mit Icons',
      'Plug & Play Setup'
    ],
    image: '/images/elgato-stream-deck-mk2.jpg',
    popular: true,
    streamingBenefits: 'Revolutioniert deinen Streaming-Workflow! Mit dem Stream Deck steuerst du OBS, wechselst Szenen, startest Timer und bedienst alle wichtigen Funktionen mit einem Fingertipp. Perfekt für professionelle Streams - keine Mausklicks mehr während des Streams nötig.'
  },
  {
    id: 'webcam-obsbot-tail-air',
    name: 'OBSBOT Tail Air NDI Streaming Camera 4K',
    description: 'KI-Tracking PTZ Kamera mit intelligenter App und Wireless-Streaming',
    price: 589,
    originalPrice: 649,
    amazonRef: 'https://amzn.to/4pdccNE',
    category: 'premium',
    features: [
      '4K NDI Streaming',
      'KI-Tracking PTZ Kamera',
      'Wireless Streaming',
      'Intelligente App-Steuerung'
    ],
    image: '/images/obsbot-tail-air.jpg',
    popular: true,
    streamingBenefits: 'Die Zukunft des Streamings! Diese 4K-Kamera folgt dir automatisch mit KI-Tracking, filmt dich in perfekter Qualität und streamt drahtlos. Perfekt für dynamische Streams - du bewegst dich frei, die Kamera macht den Rest. Ideal für Gaming, Fitness oder interaktive Content-Formate.'
  },
  {
    id: 'webcam-obsbot-tiny2',
    name: 'OBSBOT Tiny 2 PTZ 4K Webcam',
    description: '4K Webcam mit KI-Tracking, Sprachsteuerung und Gestensteuerung',
    price: 357,
    originalPrice: 399,
    amazonRef: 'https://amzn.to/4mz3iYx',
    category: 'premium',
    features: [
      '4K Video Qualität',
      'KI-Tracking Technologie',
      'Sprach- und Gestensteuerung',
      'USB 3.0 Anschluss'
    ],
    image: '/images/obsbot-tiny2.jpg',
    popular: true,
    streamingBenefits: 'Dein intelligenter Streaming-Partner! Diese 4K-Webcam folgt dir automatisch, reagiert auf deine Gesten und steuert sich per Sprachbefehl. Perfekt für professionelle Streams - du bleibst immer im Fokus, auch wenn du dich bewegst. Ideal für Gaming, Tutorials oder interaktive Shows.'
  },
  {
    id: 'light-stands-amazon-basics',
    name: 'Amazon Basics Kamera Beleuchtungsstativ 2er-Pack',
    description: 'Aluminium Beleuchtungsstative für Studio- und On-Location-Fotos',
    price: 30.02,
    originalPrice: 39.99,
    amazonRef: 'https://amzn.to/4pneZUC',
    category: 'starter',
    features: [
      '2,04 m Höhe verstellbar',
      'Max. Belastung 3,17 kg',
      'Aluminium Konstruktion',
      '2er-Pack für besseres Setup'
    ],
    image: '/images/amazon-basics-light-stands.jpg',
    streamingBenefits: 'Das Fundament deines Streaming-Setups! Diese stabilen Aluminium-Stative halten deine Beleuchtung perfekt positioniert. Mit 2 Stativen schaffst du professionelle 3-Punkt-Beleuchtung für optimale Ausleuchtung. Kompakt, leicht und trotzdem robust - perfekt für jeden Streamer.'
  },
  {
    id: 'mic-arm-rode-psa1',
    name: 'RØDE PSA1 Rundfunk-Gelenkarmstativ',
    description: 'Professionelles Mikrofonstativ für Studio-Qualität',
    price: 79,
    originalPrice: 89,
    amazonRef: 'https://amzn.to/41RI80d',
    category: 'pro',
    features: [
      'Rundfunk-Qualität',
      'Flexibler Gelenkarm',
      'Stabile Konstruktion',
      'Einfache Montage'
    ],
    image: '/images/rode-psa1.jpg',
    streamingBenefits: 'Professionelle Audio-Qualität für deinen Stream! Dieser Rundfunk-Gelenkarm positioniert dein Mikrofon perfekt vor deinem Mund, ohne im Bild zu stören. Die stabile Konstruktion eliminiert Vibrationen und sorgt für kristallklaren Sound. Ein Muss für jeden ernsthaften Streamer.'
  },
  {
    id: 'lighting-neewer-700w',
    name: 'NEEWER 700W Softbox Beleuchtung Set',
    description: '2Pack 5500K CFL Beleuchtung mit 24x24 Zoll Softboxen',
    price: 121.99,
    originalPrice: 149.99,
    amazonRef: 'https://amzn.to/47J6VY4',
    category: 'pro',
    features: [
      '700W Äquivalent Leistung',
      '5500K Tageslicht',
      '24x24 Zoll Softboxen',
      'E27 Sockel Kompatibilität'
    ],
    image: '/images/neewer-700w-softbox.jpg',
    streamingBenefits: 'Professionelle Studio-Beleuchtung für deinen Stream! Diese 700W Softboxen sorgen für perfekte, weiche Ausleuchtung ohne harte Schatten. Mit 5500K Tageslicht-Farbe siehst du natürlich und professionell aus. Ideal für Gaming-Streams, Tutorials oder Interviews.'
  },
  {
    id: 'lighting-neewer-660-led',
    name: 'NEEWER 660 LED Videolicht Panel 2 Set',
    description: 'Bi Farbe CRI96+ Videoleuchte mit Stativ und Diffusor',
    price: 258.89,
    originalPrice: 299.99,
    amazonRef: 'https://amzn.to/46jBDoi',
    category: 'pro',
    features: [
      'Bi-Farbe LED Panel',
      'CRI96+ Farbwiedergabe',
      'Faltbare Diffusoren',
      '75" Lichtstative inklusive'
    ],
    image: '/images/neewer-660-led.jpg',
    streamingBenefits: 'Premium LED-Beleuchtung für professionelle Streams! Diese Bi-Farbe Panels passen sich jeder Tageszeit an - von warmem Morgenlicht bis kühlem Abendlicht. Mit CRI96+ siehst du natürlich und farbecht aus. Perfekt für 24/7-Streamer oder Content-Creator mit flexiblen Zeiten.'
  },
  {
    id: 'diffusor-neewer-softbox',
    name: 'NEEWER Faltbarer Softbox Diffusor',
    description: '12.2"x11.4" Faltbarer Diffusor mit Gitter für LED Panels',
    price: 59.99,
    originalPrice: 79.99,
    amazonRef: 'https://amzn.to/4glt4Op',
    category: 'starter',
    features: [
      '12.2"x11.4" Größe',
      'Faltbar für Transport',
      'Gitter inklusive',
      'Kompatibel mit LED Panels'
    ],
    image: '/images/neewer-softbox-diffusor.jpg',
    streamingBenefits: 'Weiche, professionelle Ausleuchtung für deinen Stream! Dieser Diffusor verwandelt hartes LED-Licht in sanftes, schmeichelndes Licht. Perfekt für Porträt-Streams oder wenn du eine natürlichere Ausstrahlung möchtest. Kompakt faltbar - ideal für mobile Streamer.'
  },
  {
    id: 'mic-wireless-rode-go2',
    name: 'RØDE Wireless GO II',
    description: 'Ultrakompaktes kabelloses Zweikanal-Mikrofonsystem mit 200m Reichweite',
    price: 194.70,
    originalPrice: 229.99,
    amazonRef: 'https://amzn.to/3IaUWIk',
    category: 'premium',
    features: [
      'Kabellose Übertragung',
      '200m Reichweite',
      'Zweikanal-System',
      'Integrierte Aufnahmefunktion'
    ],
    image: '/images/rode-wireless-go2.jpg',
    popular: true,
    streamingBenefits: 'Absolute Freiheit beim Streamen! Mit diesem kabellosen Mikrofon bewegst du dich frei im Raum, ohne an Kabel gebunden zu sein. Perfekt für Gaming-Streams, Fitness-Content oder interaktive Shows. Die 200m Reichweite gibt dir maximale Flexibilität - ideal für große Räume oder Outdoor-Streams.'
  },
  {
    id: 'phone-rig-smallrig-3384c',
    name: 'SMALLRIG Universal Phone Video Rig Kit',
    description: 'Telefonstabilisator-Rig mit Stativmikrofon, LED-Licht, seitlichem Griff und Powerbank-Halterung',
    price: 161.91,
    originalPrice: 199.99,
    amazonRef: 'https://amzn.to/3HZAZnP',
    category: 'starter',
    features: [
      'Universal Smartphone-Halterung',
      'LED-Licht für bessere Beleuchtung',
      'Seitliche Griffe für stabile Aufnahme',
      'Powerbank-Halterung für lange Streams',
      'Stativmikrofon inklusive'
    ],
    image: '/images/smallrig-phone-rig-3384c.jpg',
    streamingBenefits: 'Perfekt für Mobile Streaming! Dieses Rig verwandelt dein Smartphone in eine professionelle Streaming-Kamera. Mit LED-Licht, Mikrofon und stabilen Griffen streamst du in hoher Qualität von überall. Ideal für Vlogging, Live-Events oder spontane Streams unterwegs.'
  }
];

export const bundles: Bundle[] = [
  {
    id: 'starter-bundle',
    name: 'Lighting Essentials',
    description: 'Unser Empfehlung für den Einstieg in professionelle Streaming-Beleuchtung',
    amazonRef: 'https://amzn.to/4pmqfk7',
    category: 'starter',
    features: [
      'GVM 800D RGB Videolicht Panel mit Stativ Set',
      'Mojimdo 180 LED Videolicht mit Handyhalter (2er Pack)'
    ],
    image: '/images/starter-bundle.jpg',
    products: [
      products.find(p => p.id === 'light-stands-amazon-basics')!,
      products.find(p => p.id === 'diffusor-neewer-softbox')!
    ],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'Empfehlung'
  },
  {
    id: 'pro-bundle',
    name: 'Creator Pro Setup',
    description: 'Unsere Empfehlung für ambitionierte Content Creator',
    amazonRef: 'https://amzn.to/47IfzGe',
    category: 'pro',
    features: [
      'KLIM® Wind Laptop Kühler (Blau) – 2x',
      'ASUS TUF Gaming A17 FA707NUR Laptop (RTX 4050, 16GB/1TB)',
      'UGREEN Revodok 1071 USB C Hub 5Gbps (4K HDMI, PD100W)',
      'RØDE PSA1 Rundfunk-Gelenkarmstativ (Schwarz, PSA1)',
      'Elgato Stream Deck MK.2 – Studio-Controller',
      'OBSBOT Tail Air NDI Streaming Camera 4K',
      'Shure MV7+ Podcast Mikrofon (Gen 2, Schwarz)'
    ],
    image: '/images/pro-bundle.jpg',
    products: [
      products.find(p => p.id === 'stream-deck-elgato-mk2')!,
      products.find(p => p.id === 'mic-arm-rode-psa1')!,
      products.find(p => p.id === 'lighting-neewer-700w')!,
      products.find(p => p.id === 'light-stands-amazon-basics')!
    ],
    setupIncluded: true,
    supportIncluded: true,
    popular: true,
    badge: 'Beliebt'
  },
  {
    id: 'premium-bundle',
    name: 'Mobile Streaming',
    description: 'Unsere Empfehlung für mobile Streaming-Setups',
    amazonRef: 'https://amzn.to/48e0Wui',
    category: 'premium',
    features: [
      'Rollei Steady Butler Mobil 3 SE Gimbal Smartphone 3 Achsen',
      'Hiluckey Powerbank 26800mAh Externer Akku',
      'RØDE Wireless GO II Kabelloses Zweikanal-Mikrofonsystem',
      'SMALLRIG Universal Phone Video Rig Kit 3384C'
    ],
    image: '/images/premium-bundle.jpg',
    products: [
      products.find(p => p.id === 'phone-rig-smallrig-3384c')!
    ],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'Mobile'
  }
  ,
  {
    id: 'thomann-rodecaster-pro-ii',
    name: 'RØDECaster Pro II Empfehlungen',
    description: 'Empfehlungen rund um den RØDECaster Pro II – perfekter Mixer für Streaming- und Podcast-Setups.',
    amazonRef: 'https://thmn.to/thocf/5268a18uy4',
    category: 'custom',
    features: [
      'Rode Podcast und Streamer Bundle',
      'RØDECaster Pro II White Edition',
      'RØDECaster Pro II'
    ],
    image: '/images/bundle-rodecaster-pro-ii.jpg',
    products: [],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'RØDECaster Pro II'
  },
  {
    id: 'thomann-shure-sm7b',
    name: 'Shure SM7B Empfehlungen',
    description: 'Kuratiertes Zubehör rund um das Shure SM7B – der Broadcast-Standard für Creator.',
    amazonRef: 'https://thmn.to/thocf/lr9fcuhk9m',
    category: 'custom',
    features: [
      'Focusrite Vocaster One',
      'beyerdynamic DT-770 Pro 80 Ohm',
      'Shure SM7B Podcast Bundle'
    ],
    image: '/images/bundle-shure-sm7b.jpg',
    products: [],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'Shure SM7B'
  },
  {
    id: 'thomann-streaming-helfer',
    name: 'Streaming Helfer',
    description: 'Ausgewählte Tools und Zubehör, die dein Streaming-Setup smarter und effizienter machen.',
    amazonRef: 'https://thmn.to/thocf/uzex60mlhb',
    category: 'custom',
    features: [
      'Elgato Stream Deck MK2',
      'Rode Wireless GO (Gen 3)',
      'Thomann 7 Port USB C Hub',
      'Reloop Smart Display Stand MK2',
      'XVive U45 In-Ear Monitor Wireless'
    ],
    image: '/images/bundle-streaming-helfer.jpg',
    products: [],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'Streaming Helfer'
  }
  ,
  {
    id: 'creator-advanced',
    name: 'Creator Advanced',
    description: 'Leistungsstarkes Creator-Setup mit starkem Laptop und aktivem Cooling – ideal für anspruchsvolle Streams und Multitasking.',
    amazonRef: 'https://amzn.to/3KlKwWT',
    category: 'premium',
    features: [
      'KLIM® Wind Laptop Kühler (Blau)',
      'ASUS TUF Gaming A17 FA707NUR Laptop (RTX 4050, 16GB/1TB)'
    ],
    image: '/images/bundle-creator-advanced.jpg',
    products: [],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'PC mit Power'
  }
  ,
  {
    id: 'lightning-pro',
    name: 'Lightning Pro',
    description: 'Hochwertiges Licht-Setup mit starken LED-Panels, COB-Licht und Zubehör für professionelle Ausleuchtung.',
    amazonRef: 'https://amzn.to/42H69as',
    category: 'pro',
    features: [
      'NEEWER 2x 660 PRO II 50W RGB LED Videoleuchte Panel Set (RGB660 PRO II)',
      'NEEWER FS150B 130W Bi-Color COB LED Videoleuchte (2700K–6500K)',
      'NEEWER 12" Laternen-Softbox (NEEWER Mount, Quick Release, NS6L)',
      'Amazon Basics 2er-Pack Aluminium Kamera Beleuchtungsstative (2,04 m)'
    ],
    image: '/images/bundle-lightning-pro.jpg',
    products: [],
    setupIncluded: true,
    supportIncluded: true,
    badge: 'Licht für Profis'
  }
];
